import { ComponentRef, Directive, Input, OnChanges, SimpleChanges, ViewContainerRef } from '@angular/core';

import { blockListSpotComponents } from './block-list-spot-components';

@Directive({
    selector: '[appGenericBlockListSpot]',
    standalone: true
})
export class GenericBlockListSpotDirective implements OnChanges {
    @Input()
    spotType?: string;

    @Input()
    theme?: string;

    @Input()
    spotData: any;

    constructor(private viewContainer: ViewContainerRef) {}

    ngOnChanges(change: SimpleChanges): void {
        if (change) {
            // Start out by clearing the view container
            this.viewContainer.clear();

            if (this.spotType === 'vimeoVideo') {
                this.spotType = 'video';
            }

            const componentClass: any = blockListSpotComponents.find(component => component.ref === this.spotType);

            if (componentClass === undefined) {
                // eslint-disable-next-line no-console
                console.log(`Could not find spot type: ${this.spotType}`);
                return;
            }

            const spotComponent: ComponentRef<any> = this.viewContainer.createComponent(componentClass);

            spotComponent.instance.data = this.spotData;
            spotComponent.instance.theme = this.theme;
        }
    }
}
